import {ReportItem} from "./report-item";

export class CurrentVend {
  machineId: string;
  successes: ReportItem[];
  failures: ReportItem[];

  static fromJson(dict: any): CurrentVend {
    let cv = new CurrentVend();
    return cv.fromJson(dict);
  }

  fromJson(dict: any): CurrentVend {
    this.machineId = dict.machineId;
    this.successes = [];
    this.failures  = [];

    for (let s of dict.successes) {
      this.successes.push(ReportItem.fromJson(s));
    }
    for (let f of dict.failures) {
      this.failures.push(ReportItem.fromJson(f));
    }
    return this;
  }

  static fromJsonArray(array: any[]): CurrentVend[] {
    let ret: CurrentVend[] = [];
    array.forEach(item => {
      ret.push(CurrentVend.fromJson(item));
    });
    return ret;
  }

}


// WEBPACK FOOTER //
// ./src/app/models/current-vend.ts